import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectProjectsListItems } from "../../../../../../redux/projects/selector";
import { projects } from "../../../../../../redux/projects/action";

const ManagementProjects = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const [pageData, setPageData] = useState(1)
  const itemsData = useSelector(selectProjectsListItems)
  const [ columnDefs,setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
      setColumnDefs([
        {
          field: 'Sl',
          sortable: false,
          filter: false,
          isSortLabel: true,
          headerName: 'Sl',
          cellRenderer (params: any) {
            return parseInt(
              params.node.id,
              10
            ) + 1;
          },
        },
        { field: 'Name', headerName: 'Name' },
        { 
          field: 'ProjectStateId', headerName: 'Project State', 
          cellRenderer: 'libraryRendererComponent', 
          // cellRendererParams: { library: this.projectState } 
        },
        { 
          field: 'ProjectPriorityId', headerName: 'Project Priority', 
          cellRenderer: 'libraryRendererComponent', 
          // cellRendererParams: { library: this.projectPriority } 
        },
        { field: 'StartDateTimeInUtc', headerName: 'Start Date', isDateValueFormat: true },
        { field: 'EndDateTimeInUtc', headerName: 'End Date', isDateValueFormat: true },
        { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
        { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true }
      ]);
    }
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
    
    navigate(`${data?.Id}`)
  }
      
  const handleDelete=(data: any)=>{
    dispatch(projects.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/psa/projects/delete`,
      entity: 'projects',
      jsonData: {
        Records: [
          {
            Id: data?.Id
          }
        ]
      }
  })).then(() => {
    dispatch(projects.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/psa/projects/list`,
      entity: 'projects',
      jsonData: { "PageNumber": pageData,
      "PageSize": 10,
      "SortField": "Id",
      "SortOrder": "desc",}
    }));
  });
  }
  
//   const additionButtons: any = [
//     {
//       name: 'Add Projects',
//       callback: () => handleAdd(),
//     }
//   ];

  const fetchProjects=()=>{

    dispatch(projects.list({
      url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/psa/projects/list`,
      entity:'projects',
      jsonData:{
      "PageNumber": pageData,
      "PageSize": 10,
      "SortField": "Id",
      "SortOrder": "desc"
    }}))     
  }
	useEffect(() => {
   
    createColumnDefs()
    fetchProjects()
	}, [pageData])
    

	return (
    <>
    {itemsData?.isLoading ? 
    <PageLoader /> : 
    <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
    paginationData={itemsData?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} headingName="Projects" />
    }
    </>
	);
};

export default ManagementProjects;


